import { render, staticRenderFns } from "./SingleCourseDetail.vue?vue&type=template&id=ec7acc82&scoped=true"
import script from "./SingleCourseDetail.vue?vue&type=script&lang=js"
export * from "./SingleCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./SingleCourseDetail.vue?vue&type=style&index=0&id=ec7acc82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7acc82",
  null
  
)

export default component.exports